var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"button-back",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-icon',{attrs:{"medium":""}},[_vm._v("chevron_left")]),_vm._v(" Back ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }